import { useState } from 'react';
import { useT } from '@/i18n/LanguageContext';

/**
 * 共有フォルダー設定の不備を**管理者に一度だけ**知らせる。
 *
 * 2026-06 本番: 配備環境の変数からバックスラッシュが落ちた結果、この注意書きが
 * 全案件の書類登録ダイアログに出続けた。直せるのは管理者だけなので、
 * API 側で管理者以外には空文字を返し、ここでは一度「了解」すれば
 * 同じ内容の間は再表示しない（内容が変わればまた出る）。
 */
const KEY = 'sensbey.nasConfigNoticeDismissed';

export const NasConfigNotice = ({ message }) => {
  const { t } = useT();
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(KEY) === message; } catch { return false; }
  });
  if (!message || hidden) return null;
  const dismiss = () => {
    try { localStorage.setItem(KEY, message); } catch { /* noop */ }
    setHidden(true);
  };
  return (
    <div className="mt-1 rounded border border-amber-200 bg-amber-50 px-2 py-1.5 text-xs text-amber-900"
      data-testid="dev-design-doc-config-warning">
      <p className="font-semibold">{t('dev.nas.adminNotice')}</p>
      <p className="mt-0.5">{message}</p>
      <button type="button" onClick={dismiss} className="mt-1 underline hover:no-underline"
        data-testid="dev-design-doc-config-warning-dismiss">
        {t('dev.nas.dismiss')}
      </button>
    </div>
  );
};

export default NasConfigNotice;
